<template>
  <div id="class">
    <template v-if="product">
      <ProductBanner
          :product="product"
          use-apply-button="true"
      ></ProductBanner>
    </template>

    <div class="inner">
      <div class="swiper-containter swiper-lnb">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#section1" v-smooth-scroll>강의소개</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#section2" v-smooth-scroll>강의차별성</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#section3" v-smooth-scroll>강의구성</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#section4" v-smooth-scroll>강의성과</a></div>
          <div class="swiper-slide" style="width:auto !important; margin-right:32px;"><a href="#section5" v-smooth-scroll>REVIEW</a></div>
        </div>
      </div>

      <div class="inner-wrap">
        <div class="content">
          <div class="content1" id="section1">
            <p class="sub">MADSCIENTERZ’ 트레이딩 강의는 <br class="dp-no">300을 따고 100을 잃는 <strong>간단하지만 강력한 트레이딩</strong>을 가능하게 합니다.</p>
            <p class="exp">명확하지만 간단하고 수익률이 좋은 매매를 장기간 할 수 있는 능력을 키워주는 것 ( 매매는 은퇴가 없음, 평생 해야 하는 것 ) <br>300을 따고 100을 잃는것을 1:1의 비율로 계속 누적하여서 크게 먹고 작게 싸는 사이클을 지속적으로 반복하면서 점진적인 우상향을 계속 만들어주는게 강의의 포인트</p>
          </div>

          <div class="content2" id="section2">
            <h3 class="tit">강의 차별성</h3>
            <p class="exp">단순한 타점이나 패턴의 통계를 정보로 공유하는 강의가 아닌 타점과 패턴의 원리와 이를 실전에 명확하게 적용하는 방법에 대해서 내용을 담고 있음 <br>강의와 같은 원리로 만들어져 배포되는 알고리즘을 통해서 타점이 시드를 우상향 시키는 신뢰도를 체크 할 수 있음 ( 알고리즘은 별도 상품, 알고리즘 이용자는 현재 누적사용자 1000명 )</p>
            <div class="cnt-bn">
              <router-link to="/algorithms">
                <img src="~@/assets/images/sub/class-cnt-bn.png" alt="알고리즘 배너" class="dp-no">
                <img src="~@/assets/images/sub/class-cnt-bn-mob.png" alt="알고리즘 배너" class="dp-mo">
              </router-link>
            </div>
          </div>

          <div class="content3" id="section3">
            <h3 class="tit">강의 구성</h3>
            <ul class="tx-box">
              <li><b>1강</b>종목선정</li>
              <li><b>2강</b>매매법</li>
              <li><b>3강</b>시드관리</li>
            </ul>
            <p class="exp">강의의 구성은 [ 1강 종목선정 / 2강 매매법 / 3강 시드관리 ] 로 이루어져 있습니다. <br>강의와 함께 오버슈팅시의 매도를 포착 할 수 있는 보조지표 (OS기법 지표)
              마진이용시 롱과 숏을 필터링 해주는 보조지표 (FL라인 지표), 두개의 기능을 지닌 통합 지표가 추가로 전송 됩니다.</p>
          </div>

          <div class="content4" id="section4">
            <h3 class="tit">강의 성과</h3>
            <p class="exp">종목선정, 매매법, 시드관리에 대한 내용이 명확하여 240명 가량의 누적수강생이 있지만 모두 타점 잡는 위치와 시드변화 그래프가 거의 비슷함</p>
            <p class="exp">단순하게 많은 수강생들중 소수의 인원만 장 좋을때 몰빵을 해서 고수익의 인원들만 가지고 통계를 내는 것이 아닌 카톡방에서 같이 강의내용 QnA를 진행하면서 상승장, 하락장, 횡보장을 모두 겪으면서 이루어낸 성과임</p>
          </div>

          <div class="content5" id="section5">
            <h3 class="tit">REVIEW</h3>
            <ReviewCardList column="2"></ReviewCardList>
            <button type="button" class="btn-sml btn-review">Read more</button>
          </div>

          <div class="content6" id="section6">
            <h3 class="tit">DISTRIBUTED BY SSABU</h3>
            <p class="exp">‘정통 트레이딩을 트렌디하게’ 라는 슬로건으로 어려운 차트이론 보다는 간단하지만 의미있는 통계/원리를 기반한 트레이딩 원칙과 아이디어, 그리고 노하우를 공유합니다. </p>
            <div class="swiper-container swiper-sns swiper-sns">
              <div class="swiper-wrapper">
                <div class="swiper-slide"><a href="https://t.me/tradingviewmania"><i class="ico-tel"></i>텔레그램</a></div>
                <div class="swiper-slide"><a href="https://open.kakao.com/o/sDFpV9X"><i class="ico-talk"></i>카카오톡</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/tradingviewmania"><i class="ico-cafe"></i>네이버카페</a></div>
                <div class="swiper-slide"><a href="https://kr.tradingview.com/u/ssabu/"><i class="ico-trade"></i>트레이딩뷰</a></div>
                <div class="swiper-slide"><a href="https://cafe.naver.com/nexontv"><i class="ico-bitman"></i>비트맨</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductBanner from "../components/ProductBanner";
import apiClient from "../../utils/instance";
import ReviewCardList from "../container/ReviewCardList";

export default {
  name: "Class",
  components: {ReviewCardList, ProductBanner},
  props: ["productCode"],
  data() {
    return {
      product: null
    }
  },
  methods: {
    scrollToElement(className) {
      this.$nextTick(function () {
        const el = this.$el.getElementsByClassName(className)[0];
        console.log(el)

        if (el) {
          el.scrollIntoView({behavior: 'smooth'});
        }
      })

    }
  },
  async mounted() {
    this.product = (await apiClient.instance.get('/products/' + this.productCode)).data
  }
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';
</style>
